<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Add Document</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.stop.prevent="addDocument"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div>
                                    <div class="row flex-grow">
                                        <div class="col-12 grid-margin">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-6 col-sm-6">
                                                            <b-form-group label="Name" label-for="Name">
                                                                <b-form-input type="text" id="Name" v-model="documentData.DocName"
                                                                    name="DocName" autocomplete="Name"
                                                                    :state="$v.documentData.DocName.$dirty ? !$v.documentData.DocName.$error : null"
                                                                    placeholder="Name">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>

                                                            <b-form-group label="Module" label-for="Module">
                                                                <b-form-select @change="getWeeksByModule" name="Module"
                                                                    v-model="documentData.DocModule" :options="allModules"
                                                                    :state="$v.documentData.DocModule.$dirty ? !$v.documentData.DocModule.$error : null"
                                                                    id="Module" class="mb-3" value-field="ModuleID" text-field="ModuleName">
                                                                </b-form-select>

                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                            <div role="group" class="form-group">
                                                                <label for="Week" class="d-block">Week</label>
                                                                <div>
                                                                    <select v-model="documentData.WeekID" class="custom-select"
                                                                        id="Week" required name="Week">
                                                                        <option v-for="(week,index) in allWeeks" :value="week.WeekNumber"
                                                                            :key="index">{{ week.WeekName }} week - {{ week.WeekNumber
                                                                            }}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <b-form-group label="Starting Date" label-for="date">
                                                                <b-form-input type="date" id="date" v-model="documentData.StartingDate"
                                                                    name="Name" autocomplete="date" placeholder="date">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>

                                                            <b-form-group label="Ending Date" label-for="edate">
                                                                <b-form-input type="date" id="edate" v-model="documentData.EndingDate"
                                                                    name="Name" autocomplete="date" placeholder="date">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>

                                                            <b-form-group label="Document order" label-for="order">
                                                                <b-form-input type="number" id="order"
                                                                    :state="$v.documentData.DocOrder.$dirty ? !$v.documentData.DocOrder.$error : null"
                                                                    v-model="documentData.DocOrder" name="DocOrder" autocomplete="order"
                                                                    placeholder="order">

                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>



                                                            <b-form-group class="input-group custom-file-button">
                                                                <label class="input-group-text" for="file">Upload</label>
                                                                <input class="form-control" type="file" id="file" @change="pdfSave" required
                                                                    name="uploadDocument" accept="application/pdf" />
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>

                                                        </div>
                                                        <div class="col-md-6 col-sm-6">
                                                            <b-form-group label="Description:" label-for="Description">
                                                                <b-form-textarea id="Description" v-model="documentData.DocDescription"
                                                                    :state="$v.documentData.DocDescription.$dirty ? !$v.documentData.DocDescription.$error : null"
                                                                    placeholder="Enter something..." rows="3" max-rows="3">
                                                                </b-form-textarea>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                            <b-form-group>
                                                                <div class="checkboxes row">
                                                                    <div class="checkbox-field col-md-6 ">
                                                                        <th><input id="Webinar" @input="updateStatus('Webinar',$event.target.checked)"
                                                                                name="Webinar" type="checkbox"> <label
                                                                                for="Webinar">Webinar 1</label>
                                                                        </th>
                                                                    </div>
                                                                    <div class="checkbox-field col-md-6 ">
                                                                        <th><input id="ScottNotes" @input="updateStatus('ScottNotes',$event.target.checked)" 
                                                                                type="checkbox"><label for="ScottNotes">Scott
                                                                                Notes</label>
                                                                        </th>
                                                                    </div>
                                                                    <div class="checkbox-field col-md-6 ">
                                                                        <th><input id="Active" @input="updateStatus('Active',$event.target.checked)" 
                                                                                type="checkbox"><label for="Active">Active</label> </th>
                                                                    </div>
                                                                    <div class="checkbox-field col-md-6 ">
                                                                        <th><input id="Archive" @input="updateStatus('Archive',$event.target.checked)" 
                                                                                type="checkbox"><label for="Archive">Archive</label>
                                                                        </th>
                                                                    </div>
                                                                </div>
                                                            </b-form-group>
                                                            <b-form-group>
                                                                <h5 class="text-danger">Skill Sets:</h5>
                                                                <div class="checkboxes row">
                                                                    <div class="checkbox-field col-md-6 " v-for="(skill,index) in skills"
                                                                        :key="index">
                                                                        <th> <input :id="'s' + skill.SkillSetID" :value="skillSetIds[skill.SkillSetID]"
                                                                                @input="updateSkillSetId(skill.SkillSetID, $event.target.checked)"
                                                                                name="Webinar" type="checkbox">
                                                                            <label :for="`s${skill.SkillSetID}`">{{ skill.SkillSetName
                                                                            }}</label>
                                                                        </th>
                                                                    </div>
                                                                </div>
                                                            </b-form-group>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
    name: "add_document_form",
    mixins: [validationMixin],
    data() {
        return {
            allModules: [
                {
                    ModuleID: "",
                    ModuleName: "Select a module"
                }
            ],
            allWeeks: [
                {
                    WeekID: "",
                    WeekName: "Select a",
                    WeekNumber: ""
                }
            ],
            documentData: {
                DocName: "",
                DocModule: '',
                WeekID: "",
                StartingDate: "",
                EndingDate: "",
                DocOrder: "",
                DocDescription: "",
                DocPDF: null,
                Webinar: 0,
                ScottNotes: 0,
                Active: 0,
                Archive: 0
            },
            skills: {},
            skillSetIds: {}
        }
    },
    validations: {
        documentData: {
            DocName: {
                required
            },
            DocModule: {
                required
            },
            DocPDF: {
                required
            },
            DocDescription: {
                required
            },
            DocOrder: {
                required
            }
        }
    },
    methods: {
        updateSkillSetId(skillId, checked) {
            this.$set(this.skillSetIds, 'SkillSetID' + skillId, checked ? 1 : 0);
        },
        updateStatus(field,checked)
        {
            this.documentData[field] = checked ? 1 : 0;
        },
        pdfSave(e) {
            this.documentData.DocPDF = e.target.files[0]
        },
        getWeeksByModule() {
            API.getWeeksByModule({ moduleID: this.documentData.DocModule }, this.getWeeksByModuleCB, this.errorCB)
        },
        getWeeksByModuleCB(res) {
            res.data.forEach(element => {
                this.allWeeks.push(element)
            });
        },
        getAllModules() {
            API.getAllModules(this.getAllModulesCB, this.errorCB);
        },
        getAllModulesCB(res) {
            res.data.forEach(element => {
                this.allModules.push(element)
            });
        },
        addDocument() {
            this.$v.documentData.$touch();
            if (this.$v.documentData.$anyError) {
                return;
            }
            API.addDocument({ ...this.documentData, ...this.skillSetIds }, this.addDocumentCB, this.errorCB);
        },
        addDocumentCB(res) {
            this.$showNotification(res, 'success')
             this.$router.push({ name: 'view_document' });
        },
        getAllSkills() {
            API.getAllSkills(this.getAllSkillsCB, this.errorCB);
        },
        getAllSkillsCB(res) {
            this.skills = res.data;
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getAllSkills();
        this.getAllModules()
    },
    components: {}
}
</script>
<style>
.custom-file-button input[type=file] {
  margin-left: -2px !important;
}
.custom-file-button input[type=file]::-webkit-file-upload-button {
  display: none;
}
.custom-file-button input[type=file]::file-selector-button {
  display: none;
}
.custom-file-button:hover label {
  background-color: #2184dab3;
  cursor: pointer;
}
.input-group-text {
    padding: 5px 30px;
    margin-bottom: 0;
    color: #fff;
    background-color: #1e77c5;
    border: 1px solid #adadad;
    border-radius: 2px;
}
.custom-file-button > div {
    display: flex;
    width: 100%;
}
</style>